import api from "../api";
import {createError, logError, logSuccess} from "./message";
import types from "./types";

function requestExpertiseList() {
  return {
    type: types.GET_ALL_EXPERTISE_REQUEST,
    fetchingExpertiseList: true
  };
}

function requestExpertiseListCompleted(expertiseList) {
  return {
    type: types.GET_ALL_EXPERTISE_COMPLETE,
    fetchingExpertiseList: false,
    expertiseList
  };
}

function requestExpertiseListError(expertiseListError) {
  return {
    type: types.GET_ALL_EXPERTISE_ERROR,
    fetchingExpertiseList: false,
    expertiseListError
  };
}

export function getExpertiseList() {
  return dispatch => {
    dispatch(requestExpertiseList());
    return api.getExpertiseList()
      .then(response => {
        if (response.status === 200) {
          dispatch(requestExpertiseListCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(requestExpertiseListError(message));
        } else {
          logError(err);
          dispatch(requestExpertiseListError(createError("Не удалось загрузить реестр экспертизы")));
        }
      });
  };
}

export default {
  getExpertiseList
}
